// extracted by mini-css-extract-plugin
export var closeButton = "_g3-1";
export var closeX = "_g3-3";
export var container = "_g3-0";
export var image = "_g3-2";